import * as queryString from 'querystring';



export function genReferralLink({
  storeId, orderNumber, customerEmail
}: {
  storeId: string;
  orderNumber: string;
  customerEmail: string;
}) {
  const hostname = window.location.hostname;
  const port = hostname === 'localhost' ? `:${window.location.port}` : '';
  const url = `${window.location.protocol}//${hostname}${port}/customer/store-referral/${storeId}`;

  const query = queryString.stringify({
    orderNumber,
    customerEmail
  });

  return `${url}?${query}`;
}
